import { classNames, twMerge } from '@panwds/tailwindcss';
export const subMenuV3Classes = {
    generic: {
        fixedWidth: 'twds-w-54',
        zeroWidth: 'twds-w-0',
        boxSizing: 'twds-box-border'
    },
    root: {
        dimensions: 'twds-h-screen',
        flex: 'twds-flex twds-flex-col',
        spacing: 'twds-mt-2'
    },
    title: {
        text: 'twds-text-steel-gray-100',
        spacing: 'twds-ml-2 -twds-p-0 twds-px-2 twds-py-5',
        border: 'twds-border-solid twds-border-0 twds-border-blue-steel-800 dark:twds-border-gray-950'
    },
    list: {
        base: 'twds-list-none twds-box-border',
        flex: 'twds-flex-1',
        spacing: 'twds-m-0 twds-p-0 twds-mb-4',
        overflow: 'overflow-y-auto twds-overflow-x-hidden',
        scroll: 'twds-scrollbar-small twds-scrollbar-no-track'
    },
    titleWrap: {
        flex: 'twds-flex twds-flex-col',
        dimensions: 'twds-w-54 twds-h-full',
        overflow: 'twds-overflow-hidden'
    }
};
export function getSubMenuNavClasses(collapsedSubNav, className) {
    return twMerge(subMenuV3Classes.generic.boxSizing, subMenuV3Classes.root.dimensions, subMenuV3Classes.root.flex, subMenuV3Classes.root.spacing, !collapsedSubNav ? subMenuV3Classes.generic.fixedWidth : subMenuV3Classes.generic.zeroWidth, className);
}
export function getSubMenuTitleClasses() {
    return classNames(subMenuV3Classes.generic.boxSizing, subMenuV3Classes.title.text, subMenuV3Classes.title.spacing, subMenuV3Classes.title.border);
}
export function getSubMenuListClasses() {
    return classNames(subMenuV3Classes.generic.boxSizing, subMenuV3Classes.list.base, subMenuV3Classes.list.spacing, subMenuV3Classes.list.flex, subMenuV3Classes.list.overflow, subMenuV3Classes.list.scroll);
}
export function getSubMenuTitleWrapClasses() {
    return classNames(subMenuV3Classes.generic.fixedWidth, subMenuV3Classes.titleWrap.flex, subMenuV3Classes.titleWrap.dimensions, subMenuV3Classes.titleWrap.overflow);
}
//# sourceMappingURL=subMenuV3.logic.js.map